import { useEffect } from 'react'
import './ErrorModal.css'

type Props = {
  title: string
  message: string
  messageNode?: React.ReactNode
  onDismiss: () => void
}

export function ErrorModal({ title, message, messageNode, onDismiss }: Props) {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onDismiss()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [onDismiss])

  return (
    <div className="buxus-error-modal" role="presentation">
      <button
        type="button"
        className="buxus-error-modal-backdrop"
        aria-label="Dismiss"
        onClick={onDismiss}
      />
      <div
        className="buxus-error-modal-panel"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="buxus-error-modal-title"
        aria-describedby="buxus-error-modal-message"
      >
        <h2 id="buxus-error-modal-title" className="buxus-error-modal-title">
          {title}
        </h2>
        <div id="buxus-error-modal-message" className="buxus-error-modal-message">
          {messageNode ?? message}
        </div>
        <button type="button" className="buxus-error-modal-ok" onClick={onDismiss}>
          OK
        </button>
      </div>
    </div>
  )
}
